module.exports = __webpack_public_path__ + "img/cave62.97d99685.jpg";